import React from "react"
import style from "./style";

const MyConsentsFake = () => {
   return (
    <>
      <div className="container my-consents-fake">
        <div className="my-consents-fake--container">
          <div className="skeleton my-consents-fake--title" />
          <div className="my-consents-fake--box">
            <div className="skeleton my-consents-fake--name" />
            <div className="skeleton my-consents-fake--descr" />
          </div>
          <div className="my-consents-fake--box">
            <div className="skeleton my-consents-fake--name" />
            <div className="skeleton my-consents-fake--descr" />
          </div>
          <div className="my-consents-fake--box">
            <div className="skeleton my-consents-fake--name" />
            <div className="skeleton my-consents-fake--descr" />
          </div>
          <div className="my-consents-fake--box">
            <div className="skeleton my-consents-fake--name" />
            <div className="skeleton my-consents-fake--descr" />
          </div>
        </div>
      </div>
        <style jsx>{style}</style>
    </>
  );
}

export default MyConsentsFake